import React, { Component } from "react"
import { Global, css } from "@emotion/core"
import Header from "../header"
import Footer from "../footer"
import PageContent from "../page-content"
import "./reset.css"

class DefaultLayout extends Component {
  render() {
    const children = this.props.children
    return (
      <>
        <Global
          styles={css`
            @import url("https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap");

            * {
              box-sizing: border-box;
            }

            html {
              font-family: "Roboto", sans-serif;
            }

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
            }

            h1 {
              font-size: 24px;
            }

            .wrapper {
              max-width: 1200px;
              margin: 0 auto;
            }

            .banner {
              background-color: red;
              padding: 3rem 1rem;
              color: #fff;
              text-align: center;
              margin-bottom: 20px;

              h1 {
                font-size: 44px;
              }
            }

            .lazyLoad {
              width: 100%;
            }
          `}
        />
        <Header />
        <PageContent children={children} />
        <Footer />
      </>
    )
  }
}

export default DefaultLayout
